module.exports = __webpack_public_path__ + "static/media/boats-green.23f3cb6c.jpg";